import { render, staticRenderFns } from "./DetailStats.vue?vue&type=template&id=5326527c&scoped=true"
import script from "./DetailStats.vue?vue&type=script&lang=js"
export * from "./DetailStats.vue?vue&type=script&lang=js"
import style0 from "./DetailStats.vue?vue&type=style&index=0&id=5326527c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5326527c",
  null
  
)

export default component.exports